module.exports = __webpack_public_path__ + "img/nodata.85729395.png";